import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { DatePickerWorkDay } from "components/CustomDatePicker";
import CustomDialog from "components/CustomDialog";
import CustomText from "components/typography/CustomText";
import { serverGet, serverPost } from "lib/serverRequest";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";

export const ResendDialog = ({
  open = false,
  selected = [],
  onClose = () => {},
  onFinishReSchedule = () => {},
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [blackoutDates, setBlackoutDates] = useState([]);
  const [sendEmail, setSendEmail] = useState(false);
  const [reSchedule, setReSchedule] = useState(false);
  const [dispatchDate, setDispatchDate] = useState("");

  const handleSendEmail = () => {
    if (!dispatchDate)
      return enqueueSnackbar("Please select the date!", { variant: "warning" });
    // if (!reSchedule)
    //   return enqueueSnackbar("Please check Re-Schedule next order!", {
    //     variant: "warning",
    //   });
    const newWeekCount = moment(dispatchDate).isoWeek();
    const newDayCount = moment(dispatchDate).isoWeekday();
    const newYearCount = moment(dispatchDate).isoWeekYear();
    const updateData = {
      selected,
      reSchedule,
      sendEmail,
      newWeekCount,
      newDayCount,
      newYearCount,
    };
    openLoading(true);
    serverPost({
      url: "weeklySlots/re_schedule",
      data: updateData,
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false)
          return enqueueSnackbar("Please try again!", {
            variant: "warning",
          });
        onFinishReSchedule(updateData);
      },
    });
  };

  useEffect(() => {
    serverGet({
      url: "blackout-day",
      onFinish: (res, err) => {
        if (res === false) {
          return;
        }
        setBlackoutDates((s = []) =>
          res.map((item) => new Date(item.blackout_day))
        );
      },
    });
    //eslint-disable-next-line
  }, []);

  return (
    <CustomDialog
      title="Re-send Order"
      open={open}
      isAction={true}
      onClose={onClose}
    >
      <div className="flex justify-between items-center">
        <CustomText
          className="text-base text-light-gray"
          color="secondary"
          variant="body"
        >
          Select Dispatch Date
        </CustomText>
        <DatePickerWorkDay
          className="px-3 py-1 border rounded border-white-gray w-100"
          dateFormat="dd/MM/yyyy"
          excludeDates={blackoutDates}
          selected={dispatchDate}
          minDate={new Date()}
          disabledays
          withPortal
          onChange={(v) => setDispatchDate(v)}
        />
      </div>
      <div className="py-3">
        <FormControlLabel
          control={
            <Checkbox
              value={sendEmail}
              onChange={(e) => setSendEmail(e.target.checked)}
            />
          }
          label="Send Email to Customer"
        />
        <FormControlLabel
          control={
            <Checkbox
              value={reSchedule}
              onChange={(e) => setReSchedule(e.target.checked)}
            />
          }
          label="Re-Schedule Next Order"
        />
      </div>
      <div className="flex justify-end items-center">
        <Button
          className="mx-2 px-4 font-bold font-zing text-base"
          color="primary"
          variant="contained"
          onClick={handleSendEmail}
        >
          Send
        </Button>
        <Button
          className="mx-2 px-4 font-bold font-zing text-base"
          color="secondary"
          variant="contained"
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </CustomDialog>
  );
};
